import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const breadcrumbDefaultVariants = {
  "size": "md"
}
const breadcrumbCompoundVariants = []

const breadcrumbSlotNames = [
  [
    "root",
    "Breadcrumb__root"
  ],
  [
    "wrapper",
    "Breadcrumb__wrapper"
  ],
  [
    "separator",
    "Breadcrumb__separator"
  ],
  [
    "placeholder",
    "Breadcrumb__placeholder"
  ],
  [
    "item",
    "Breadcrumb__item"
  ],
  [
    "popover",
    "Breadcrumb__popover"
  ],
  [
    "list",
    "Breadcrumb__list"
  ],
  [
    "listItem",
    "Breadcrumb__listItem"
  ],
  [
    "link",
    "Breadcrumb__link"
  ]
]
const breadcrumbSlotFns = /* @__PURE__ */ breadcrumbSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, breadcrumbDefaultVariants, getSlotCompoundVariant(breadcrumbCompoundVariants, slotName))])

const breadcrumbFn = memo((props = {}) => {
  return Object.fromEntries(breadcrumbSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const breadcrumbVariantKeys = [
  "size"
]
const getVariantProps = (variants) => ({ ...breadcrumbDefaultVariants, ...compact(variants) })

export const breadcrumb = /* @__PURE__ */ Object.assign(breadcrumbFn, {
  __recipe__: false,
  __name__: 'breadcrumb',
  raw: (props) => props,
  variantKeys: breadcrumbVariantKeys,
  variantMap: {
  "size": [
    "sm",
    "md"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, breadcrumbVariantKeys)
  },
  getVariantProps
})